<template>
  <div>
    <v-row class="mt-3 ml-2">
      <v-col cols="12" sm="6">
        <v-switch dense
                  class="pa-0 mt-2 mr-2"
                  label="Criar hierarquia de aprovação"
                  color="primary"
                  v-model="criaHierarquia"/>
      </v-col>
      <v-col cols="12" sm="6" class="text-right">
        <v-btn color="error"
               class="rounded-tag-small normal-btn-text elevation-0"
               :loading="loadingRemove"
               :disabled="loadingSave"
               @click="onClickRemove">
          <v-icon>mdi-close</v-icon>
          Remover alçadas
        </v-btn>
      </v-col>
    </v-row>
    <template v-if="regras && regras.length">
      <px-alcadas-list-item v-for="(regra, index) in regras"
                            class="mt-5"
                            :regra="regra"
                            :numeroRegra="index + 1"
                            :regras="regras"
                            :key="regra.$$id"
                            :opcoes-criterios="opcoesCriterios"
                            ref="regras"
                            @remove="onRemove(index)"
                            @moveDown="onMoveDown(index)"
                            @moveUp="onMoveUp(index)"/>
    </template>
    <v-row dense class="mt-3">
      <v-col cols="12" class="text-right">
        <v-btn small class="rounded-tag-small normal-btn-text elevation-0"
               color="primary"
               @click="addRegra">
          <v-icon small>mdi-plus</v-icon>
          Regra
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn color="primary"
               class="rounded-tag-small normal-btn-text elevation-0"
               :loading="loadingSave"
               :disabled="loadingRemove"
               @click="onClickSave">
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AlcadasListItem from '@/modules/alcadas/components/AlcadasListItem.vue';
import { initialStateRegra } from '@/modules/alcadas/components/alcadas-utils';
import { sortBy } from 'lodash';

export default {
  props: {
    opcoesCriterios: Array,
    alcadas: {
      type: Object,
    },
    loadingSave: Boolean,
    loadingRemove: Boolean,
  },
  data() {
    return {
      criaHierarquia: true,
      regras: [],
    };
  },
  methods: {
    addRegra() {
      this.regras.push(initialStateRegra());
    },
    onRemove(index) {
      if (this.regras.length === 1) {
        return;
      }
      this.regras.splice(index, 1);
    },
    onMoveDown(index) {
      if (index === this.regras.length - 1) {
        return;
      }
      const regra = this.regras[index];
      this.regras.splice(index, 1);
      this.regras.splice(index + 1, 0, regra);
    },
    onMoveUp(index) {
      if (index === 0) {
        return;
      }
      const regra = this.regras[index];
      this.regras.splice(index, 1);
      this.regras.splice(index - 1, 0, regra);
    },
    onClickSave() {
      if (!this.isValid()) {
        return;
      }
      this.$emit('save', {
        regras: this.regras,
        criaHierarquia: this.criaHierarquia,
      });
    },
    onClickRemove() {
      this.$emit('remove');
    },
    isValid() {
      return this.$refs.regras.every(ref => ref.isValid());
    },
  },
  created() {
    if (!this.alcadas) {
      this.regras = [initialStateRegra()];
      return;
    }
    this.regras = sortBy(this.alcadas.regras, 'sequencia');
    this.criaHierarquia = this.alcadas.criaHierarquia;
  },
  components: {
    pxAlcadasListItem: AlcadasListItem,
  },
};
</script>
